
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonComponent } from '@knorr-bremse-portals/ngx-components/components/button';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';

import { UserConsent } from '../../../app/providers/user-consent.service';

@Component({
  selector: 'app-user-consent-dialog',
  templateUrl: './user-consent-dialog.component.html',
  styleUrls: ['./user-consent-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CardComponent,
    ButtonComponent,
  ],
})
export class UserConsentDialogComponent {

  @Input() public consent!: UserConsent;

  protected doAccept(event: MouseEvent) {
    event.preventDefault();
    this.consent.consent();
  }

}
